import React, { Component } from "react";
import { Table, Row, Col, Tooltip, DatePicker, Icon } from "antd";
import axios from "axios";
import "./Pages.css";
import moment from "moment-timezone";
import { getUsuario, getTemPermissao, getTipoUsuario } from "../utils/LoginManager";
import { maskDate } from "../utils/Masker";
import UsuarioFrame from '../components/UsuarioFrame';
import AtividadesVendedoresPrintModal from "../relatorios/AtividadesVendedoresPrintModal";
import numeral from "numeral";
import TipoAtividadeFrame from '../components/TipoAtividadeFrame';
import InputForm from "../components/InputForm";

const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const { RangePicker } = DatePicker;


export default class extends Component {
  state = {
    usuarioSelect: [],

    listaResumo: [],
    listaVisitas: [],
    listaEscritorio: [],
    listaTransito: [],
    listaAbastec: [],
    listaOutros: [],

    kmTotal: 0,
    combTotal: 0,

    carregando: false,
    qtdeTotal: 0,

    formVisivel: false,
    formFiltroVisivel: false,
    filtros: {
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaUsuario: { key: '0', },
      buscaAtividade: { key: '0', },
      buscaVisitaVenda: false
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    getTipoUsuario().then(tipoUsuario => {
      this.state.filtros.buscaUsuario = {
        key: usuario.usu_cpf,
        label: usuario.usu_nome + ' [' + usuario.usu_cpf + ']'
      }
      this.setState({
        usuario,
        tipoUsuario,
      }, this.getListaRegistros);
    })
  }

  componentDidUpdate(antProps, antState) {

  }



  getListaRegistros = () => {
    this.setState({ carregando: true, qtdePed: 0, qtdeOrc: 0, vlrTotalPed: 0, vlrTotalOrc: 0 });
    const { buscaDataIni, buscaDataFim, buscaUsuario, buscaAtividade, buscaVisitaVenda } = this.state.filtros;

    let ativ_data_ativ_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      ativ_data_ativ_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let ativ_data_ativ_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      ativ_data_ativ_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/atividades/listaAtividadesVendedores', {
        params: {
          usuario: buscaUsuario.key,
          atividade: buscaAtividade.key,
          ativ_data_ativ_ini,
          ativ_data_ativ_fim,
          venda: buscaVisitaVenda ? 1 : 0,
          print: 0,
        }
      })
      .then(response => {

        let kmTotal = 0;
        let kmRodado = 0;
        for (var x in response.data.transito) {
          kmRodado = parseFloat(response.data.transito[x].ativa_km_ini) > 0 && parseFloat(response.data.transito[x].ativa_km_fim) > 0 ? parseFloat(response.data.transito[x].ativa_km_fim) - parseFloat(response.data.transito[x].ativa_km_ini) : 0;
          kmTotal = kmTotal + kmRodado;
        };

        let combTotal = 0;
        for (var x in response.data.abastecimentos) {
          combTotal = combTotal + parseFloat(response.data.abastecimentos[x].ativa_qtde_comb);
        };


        this.setState({
          listaResumo: response.data.listaResumo,
          listaVisitas: response.data.visitas,
          listaEscritorio: response.data.escritorio,
          listaTransito: response.data.transito,
          listaAbastec: response.data.abastecimentos,
          listaOutros: response.data.outros,

          kmTotal,
          combTotal,
          carregando: false,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };



  onChangePeriodo = event => {
    const { filtros } = this.state;
    if (event[0]) {
      filtros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      filtros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      filtros.buscaDataIni = moment().format('DD/MM/YYYY');
      filtros.buscaDataFim = moment().format('DD/MM/YYYY');
    }
    this.setState({
      filtros
    },
      this.getListaRegistros
    );
  };

  onChangeVendedor = event => {
    const { filtros } = this.state;
    filtros['buscaUsuario'] = event.buscaUsuario;
    this.setState(event,
      this.getListaRegistros
    );
  }

  onChangeAtividade = event => {
    const { filtros } = this.state;
    filtros['buscaAtividade'] = event.buscaAtividade;
    this.setState(event,
      this.getListaRegistros
    );
  }

  onChangeVenda = event => {
    const { filtros } = this.state;
    const value = event.target.value;
    console.log('onChangeVenda', value)
    filtros['buscaVisitaVenda'] = value ? 1 : 0;
    this.setState(event,
      this.getListaRegistros
    );
  }

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderKm = (text, registro) => {
    const kmRodado = parseFloat(registro.ativa_km_ini) > 0 && parseFloat(registro.ativa_km_fim) > 0 ? parseFloat(registro.ativa_km_fim) - parseFloat(registro.ativa_km_ini) : 0;
    return (
      <span>
        {kmRodado}
      </span>
    )
  }

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderAtividade = (text, registro) => {
    let check;

    if (!registro.ativ_data_checkin) {
      if ((registro.ativ_hora_ini) && (registro.ativ_hora_ini != '00:00')) {
        const date1 = new Date();
        const date2 = moment(registro.ativ_data_ativ).format('DD/MM/YYYY') + ' ' + registro.ativ_hora_ini + ':00';
        if (moment(date1, "DD/MM/YYYY HH:mm:ss").diff(moment(date2, "DD/MM/YYYY HH:mm:ss")) >= 0) {
          check = 0
        } else {
          check = 1
        }
      } else {
        check = 0
      }
    } else if (!registro.ativ_data_checkout) {
      if ((registro.ativ_hora_fim) && (registro.ativ_hora_fim != '00:00')) {
        const date1 = new Date();
        const date2 = moment(registro.ativ_data_ativ).format('DD/MM/YYYY') + ' ' + registro.ativ_hora_fim + ':00';
        if (moment(date1, "DD/MM/YYYY HH:mm:ss").diff(moment(date2, "DD/MM/YYYY HH:mm:ss")) >= 0) {
          check = 0
        } else {
          check = 1
        }
      } else {
        check = 0
      }
    } else {
      check = 0
    }

    return (
      <div>
        {(registro.ativ_data_checkin && registro.ativ_data_checkout) ? (
          <Icon type="check-circle" style={{ marginRight: 5, color: "#10734a" }} />
        ) : (
          check ? (
            <Icon type="calendar" style={{ marginRight: 5, color: "#f9a825" }} />
          ) : (
            <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
          )
        )}
        <span>{registro.ac_descricao}</span>
      </div>
    )
  };

  renderCliente = (text, registro) => {
    return (
      <span>
        <Icon type={registro.ativv_cliente ? "user" : "user-delete"} style={{ fontSize: 20, marginRight: 5, color: registro.ativv_cliente ? "#10734a" : "#b71c1c" }} />
        <span>{registro.ativv_cliente ? registro.pes_nome : registro.ativv_nome_cliente}</span>
      </span>
    );
  };

  renderVenda = (text, registro) => {
    return (
      <span>
        <Icon type={registro.ativv_idf_venda ? "check" : "close"} style={{ fontSize: 20, marginRight: 0, color: registro.ativv_idf_venda ? "#10734a" : "#b71c1c" }} />
        <span>{registro.ativv_idf_venda ? 'SIM' : 'NÃO'}</span>
      </span>
    );
  };


  onAbrirMapaClick = (localizacao) => {
    if (localizacao) {
      window.open("http://maps.google.com/maps?q=" + localizacao, '_blank')
      // window.open("http://maps.google.com/maps?q=" + localizacao, "minhaJanela", "height=400,width=400");
    }
  };

  renderDataCheckIn = (text, registro) => {
    if (registro.ativ_data_checkin) {
      const dataMoment = moment(registro.ativ_data_checkin);
      return (
        <span>
          <Tooltip title="Abrir Localização no Mapa">
            <Icon type="pushpin" style={{ marginRight: 5, color: "#10734a" }} />
            <a onClick={() => this.onAbrirMapaClick(registro.ativ_local_checkin)}>
              {dataMoment.format('DD/MM/YYYY HH:mm')}
            </a>
          </Tooltip>
        </span >
      )
    } else {
      return (
        <span>
          <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
          <span>SEM CHECK-IN</span>
        </span>
      )
    }
  }

  renderDataCheckOut = (text, registro) => {
    if (registro.ativ_data_checkout) {
      const dataMoment = moment(registro.ativ_data_checkout);
      return (
        <span>
          <Tooltip title="Abrir Localização no Mapa">
            <a
              onClick={() => this.onAbrirMapaClick(registro.ativ_local_checkout)}
            >
              {dataMoment.format('DD/MM/YYYY HH:mm')}
            </a>
          </Tooltip>
        </span>
      )
    } else {
      return (
        <span>
          <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
          <span>SEM CHECK-OUT</span>
        </span>
      )
    }
  }




  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaVisitas, listaEscritorio, listaTransito, listaAbastec, listaOutros, usuarioSelect, carregando } = this.state;
    const { buscaDataIni, buscaDataFim, buscaUsuario, buscaAtividade, buscaVisitaVenda } = this.state.filtros;

    console.log('AtividadesVendedoresPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Atividades por Vendedor</h2>
        <hr />
        <br />
        <Row>
          <div className="pageFiltro" style={{ height: 70, marginTop: -20 }}>
            <Row>
              <Col xs={6} style={{ marginRight: 10, marginTop: 4 }}>
                <span>Período</span>
                <RangePicker
                  style={{ width: "100%" }}
                  masker={maskDate}
                  value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
                  format={dateFormat}
                  onChange={this.onChangePeriodo}
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginRight: 10 }}>
                <UsuarioFrame
                  label="Vendedor"
                  id="buscaUsuario"
                  value={buscaUsuario}
                  width={"100%"}
                  vendedor={1}
                  todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                  onChange={this.onChangeVendedor}
                  descricaoPrimeiroItem="Selecione um Vendedor"
                  disabled={getTemPermissao('UsuarioSupervisor', 'cons') ? false : true}
                />
              </Col>

              <Col xs={24} sm={4}>
                <TipoAtividadeFrame
                  label="Atividade"
                  id="buscaAtividade"
                  value={buscaAtividade}
                  width={"100%"}
                  vendedor={1}
                  onChange={this.onChangeAtividade}
                  descricaoPrimeiroItem="Todas as Atividades"
                />
              </Col>

              {buscaAtividade.key === '1' ? (
                <Col xs={24} sm={3} style={{ marginTop: 20, paddingLeft: 20}}>
                  <InputForm
                    type="checkbox"
                    id="buscaVisitaVenda"
                    ref="buscaVisitaVenda"
                    onChange={this.onChangeVenda}
                    value={buscaVisitaVenda}
                  >
                    Venda Fechada
                  </InputForm>
                </Col>
              ) : null}

              <Col xs={2} style={{ width: 110, marginTop: 24, marginLeft: 10 }}>
                <AtividadesVendedoresPrintModal
                  listaVisitas={listaVisitas}
                  listaEscritorio={listaEscritorio}
                  listaTransito={listaTransito}
                  listaAbastec={listaAbastec}
                  listaOutros={listaOutros}
                  buscaDataIni={this.state.filtros.buscaDataIni}
                  buscaDataFim={this.state.filtros.buscaDataFim}
                  buscaUsuario={this.state.filtros.buscaUsuario.label}
                />
              </Col>

            </Row>
          </div>
        </Row>


        {/* ----------------------------------------------------------------- */}
        {/* VISITAS --------------------------------------------------------- */}
        {/* ----------------------------------------------------------------- */}

        {listaVisitas && listaVisitas.length > 0 ? (
          <div style={{ marginBottom: 70 }}>
            <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
              <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                <Row><span style={{ fontWeight: "bold", fontSize: 24 }}>VISITAS</span></Row>
              </Col>
            </Col>

            <div style={{ marginTop: -30 }}>
              <Table
                pagination={false}
                onChange={this.onTabelaChange}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaVisitas}
                rowKey={(registro => registro.ativ_idf)}
              >
                <Column
                  key="ativ_data_ativ"
                  dataIndex="ativ_data_ativ"
                  title="Data"
                  render={this.renderData}
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_ini"
                  dataIndex="ativ_hora_ini"
                  title="Início"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_fim"
                  dataIndex="ativ_hora_fim"
                  title="Fim"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativv_nome_cliente"
                  dataIndex="ativv_nome_cliente"
                  title="Cliente"
                  render={this.renderCliente}
                  width={"15%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ativv_idf_venda"
                  dataIndex="ativv_idf_venda"
                  title="Venda"
                  render={this.renderVenda}
                  width={"5%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_obs"
                  dataIndex="ativ_obs"
                  title="Descrição"
                  width={"15%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkin"
                  dataIndex="ativ_data_checkin"
                  title="Check-In"
                  render={this.renderDataCheckIn}
                  width={"12%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkout"
                  dataIndex="ativ_data_checkout"
                  title="Check-Out"
                  render={this.renderDataCheckOut}
                  width={"12%"}
                  align="center"
                  className="listaCadastro"
                />
              </Table>
            </div>
          </div>
        ) : null}


        {/* ----------------------------------------------------------------- */}
        {/* ESCRITÓRIO ------------------------------------------------------ */}
        {/* ----------------------------------------------------------------- */}

        {listaEscritorio && listaEscritorio.length > 0 ? (
          <div style={{ marginBottom: 70 }}>
            <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
              <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                <Row><span style={{ fontWeight: "bold", fontSize: 24 }}>ESCRITÓRIO</span></Row>
              </Col>
            </Col>

            <div style={{ marginTop: -30 }}>
              <Table
                pagination={false}
                onChange={this.onTabelaChange}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaEscritorio}
                rowKey={(registro => registro.ativ_idf)}
              >
                <Column
                  key="ativ_data_ativ"
                  dataIndex="ativ_data_ativ"
                  title="Data"
                  render={this.renderData}
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_ini"
                  dataIndex="ativ_hora_ini"
                  title="Início"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_fim"
                  dataIndex="ativ_hora_fim"
                  title="Fim"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_obs"
                  dataIndex="ativ_obs"
                  title="Descrição"
                  width={"30%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkin"
                  dataIndex="ativ_data_checkin"
                  title="Check-In"
                  render={this.renderDataCheckIn}
                  width={"12%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkout"
                  dataIndex="ativ_data_checkout"
                  title="Check-Out"
                  render={this.renderDataCheckOut}
                  width={"12%"}
                  align="center"
                  className="listaCadastro"
                />
              </Table>
            </div>
          </div>
        ) : null}


        {/* ----------------------------------------------------------------- */}
        {/* TRANSITO -------------------------------------------------------- */}
        {/* ----------------------------------------------------------------- */}

        {listaTransito && listaTransito.length > 0 ? (
          <div style={{ marginBottom: 70 }}>
            <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
              <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                <Row>
                  <span style={{ fontWeight: "bold", fontSize: 24 }}>TRÂNSITO</span>
                  <span style={{ fontWeight: "bold", fontSize: 14, marginLeft: 40, marginTop: -5 }}>Km Rodado: </span>
                  <span style={{ fontSize: 14 }}>{this.state.kmTotal}</span>
                </Row>
              </Col>
            </Col>

            <div style={{ marginTop: -30 }}>
              <Table
                pagination={false}
                onChange={this.onTabelaChange}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaTransito}
                rowKey={(registro => registro.ativ_idf)}
              >
                <Column
                  key="ativ_data_ativ"
                  dataIndex="ativ_data_ativ"
                  title="Data"
                  render={this.renderData}
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_ini"
                  dataIndex="ativ_hora_ini"
                  title="Início"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_fim"
                  dataIndex="ativ_hora_fim"
                  title="Fim"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativa_km_ini"
                  dataIndex="ativa_km_ini"
                  title="Odôm Inicial"
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativa_km_fim"
                  dataIndex="ativa_km_fim"
                  title="Odôm Final"
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativa_km_rodado"
                  dataIndex="ativa_km_rodado"
                  title="Km Rodado"
                  render={this.renderKm}
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_obs"
                  dataIndex="ativ_obs"
                  title="Descrição"
                  width={"10%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkin"
                  dataIndex="ativ_data_checkin"
                  title="Check-In"
                  render={this.renderDataCheckIn}
                  width={"14%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkout"
                  dataIndex="ativ_data_checkout"
                  title="Check-Out"
                  render={this.renderDataCheckOut}
                  width={"14%"}
                  align="center"
                  className="listaCadastro"
                />
              </Table>
            </div>
          </div>
        ) : null}


        {/* ----------------------------------------------------------------- */}
        {/* ABASTECIMENTOS -------------------------------------------------- */}
        {/* ----------------------------------------------------------------- */}

        {listaAbastec && listaAbastec.length > 0 ? (
          <div style={{ marginBottom: 70 }}>
            <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
              <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                <Row>
                  <span style={{ fontWeight: "bold", fontSize: 24 }}>ABASTECIMENTOS</span>
                  <span style={{ fontWeight: "bold", fontSize: 14, marginLeft: 40, marginTop: -5 }}>Qtde Combustível: </span>
                  <span style={{ fontSize: 14 }}>{this.state.combTotal}</span>
                </Row>
              </Col>
            </Col>

            <div style={{ marginTop: -30 }}>
              <Table
                pagination={false}
                onChange={this.onTabelaChange}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaAbastec}
                rowKey={(registro => registro.ativ_idf)}
              >
                <Column
                  key="ativ_data_ativ"
                  dataIndex="ativ_data_ativ"
                  title="Data"
                  render={this.renderData}
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_ini"
                  dataIndex="ativ_hora_ini"
                  title="Início"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_fim"
                  dataIndex="ativ_hora_fim"
                  title="Fim"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativa_km"
                  dataIndex="ativa_km"
                  title="Odômetro"
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativa_qtde_comb"
                  dataIndex="ativa_qtde_comb"
                  title="Qtde Comb"
                  render={this.renderValor}
                  width={"10%"}
                  align="right"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_obs"
                  dataIndex="ativ_obs"
                  title="Descrição"
                  width={"20%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkin"
                  dataIndex="ativ_data_checkin"
                  title="Check-In"
                  render={this.renderDataCheckIn}
                  width={"12%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkout"
                  dataIndex="ativ_data_checkout"
                  title="Check-Out"
                  render={this.renderDataCheckOut}
                  width={"12%"}
                  align="center"
                  className="listaCadastro"
                />
              </Table>
            </div>
          </div>
        ) : null}


        {/* ----------------------------------------------------------------- */}
        {/* OUTROS ---------------------------------------------------------- */}
        {/* ----------------------------------------------------------------- */}

        {listaOutros && listaOutros.length > 0 ? (
          <div style={{ marginBottom: 70 }}>
            <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
              <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                <Row><span style={{ fontWeight: "bold", fontSize: 24 }}>OUTROS</span></Row>
              </Col>
            </Col>

            <div style={{ marginTop: -30 }}>
              <Table
                pagination={false}
                onChange={this.onTabelaChange}
                loading={{
                  spinning: carregando,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaOutros}
                rowKey={(registro => registro.ativ_idf)}
              >
                <Column
                  key="ativ_data_ativ"
                  dataIndex="ativ_data_ativ"
                  title="Data"
                  render={this.renderData}
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_ini"
                  dataIndex="ativ_hora_ini"
                  title="Início"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_hora_fim"
                  dataIndex="ativ_hora_fim"
                  title="Fim"
                  width={"5%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_obs"
                  dataIndex="ativ_obs"
                  title="Descrição"
                  width={"30%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkin"
                  dataIndex="ativ_data_checkin"
                  title="Check-In"
                  render={this.renderDataCheckIn}
                  width={"12%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="ativ_data_checkout"
                  dataIndex="ativ_data_checkout"
                  title="Check-Out"
                  render={this.renderDataCheckOut}
                  width={"12%"}
                  align="center"
                  className="listaCadastro"
                />
              </Table>
            </div>
          </div>
        ) : null}

        {/* ----------------------------------------------------------------- */}
        {/* ----------------------------------------------------------------- */}
        {/* ----------------------------------------------------------------- */}


        {/* <div style={{ marginTop: -30 }}>
          <Table
            pagination={false}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.ativ_idf)}
          >
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Nome Vendedor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderUsuario}
              width={"10%"}
              align="left"
              className="listaCadastro"
            />

            <Column
              key="qtdeTotal"
              dataIndex="qtdeTotal"
              title={this.renderTitulo1("Total")}
              render={this.renderQtdeTotal}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="horasTotais"
              dataIndex="horasTotais"
              title={this.renderTitulo1("Hora Totais")}
              render={this.renderHora}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="qtdeVisitas"
              dataIndex="qtdeVisitas"
              title={this.renderTitulo1("Visitas")}
              render={this.renderQtdeVisitas}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="horasVisitas"
              dataIndex="horasVisitas"
              title={this.renderTitulo1("Hora Visitas")}
              render={this.renderHora}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="qtdeEscrit"
              dataIndex="qtdeEscrit"
              title={this.renderTitulo1("Escritório")}
              render={this.renderQtdeEscrit}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="horasEscrit"
              dataIndex="horasEscrit"
              title={this.renderTitulo1("Hora Escrit")}
              render={this.renderHora}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="qtdeTransito"
              dataIndex="qtdeTransito"
              title={this.renderTitulo1("Trânsito")}
              render={this.renderQtdeTransito}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="horasTransito"
              dataIndex="horasTransito"
              title={this.renderTitulo1("Hora Trâns")}
              render={this.renderHora}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="qtdeAbast"
              dataIndex="qtdeAbast"
              title={this.renderTitulo1("Abastec.")}
              render={this.renderQtdeAbast}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="horasAbast"
              dataIndex="horasAbast"
              title={this.renderTitulo1("Hora Abast.")}
              render={this.renderHora}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="horasAbast"
              dataIndex="horasAbast"
              title={this.renderTitulo1("Km Rod")}
              render={this.renderKm}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="qtdeOutros"
              dataIndex="qtdeOutros"
              title={this.renderTitulo1("Outros")}
              render={this.renderQtdeOutros}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="horasOutros"
              dataIndex="horasOutros"
              title={this.renderTitulo1("Hora Outros")}
              render={this.renderHora}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div> */}

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/AtividadesVendedoresPage.js